/* Langford - Header Premium (BigStudio)
   Inyecta el boton CTA "Ir a la Plataforma" en la fila de iconos del header
   (desktop) y dentro del menu lateral (mobile). Idempotente y tolerante.
   No modifica el acordeon LangfordAccordionMenu del tema. */
(function () {
  'use strict';

  var CFG = window.LANGFORD_HEADER || {};
  var CTA = CFG.cta || {};

  function isExternal(url) {
    return /^https?:\/\//i.test(url) && url.indexOf('metodolangford') === -1;
  }

  function build(className) {
    var a = document.createElement('a');
    a.href = CTA.url;
    a.className = className;
    a.setAttribute('data-langford-cta', '');
    a.textContent = CTA.label || 'Ir a la Plataforma';
    if (isExternal(CTA.url)) {
      a.target = '_blank';
      a.rel = 'noopener';
    }
    return a;
  }

  function injectDesktop() {
    var icons = document.querySelector('.header__icons');
    if (!icons || icons.querySelector('.header__cta')) return;
    var cta = build('header__cta small-hide medium-hide');
    var cart = icons.querySelector('#cart-icon-bubble');
    if (cart) {
      icons.insertBefore(cta, cart);
    } else {
      icons.appendChild(cta);
    }
  }

  function injectMobile() {
    var nav = document.querySelector('.menu-drawer__navigation');
    if (!nav || nav.querySelector('.menu-drawer__cta')) return;
    nav.insertBefore(build('menu-drawer__cta'), nav.firstChild);
  }

  function run() {
    if (!CTA.url || CTA.enabled === false) return;
    injectDesktop();
    injectMobile();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', run);
})();
